export const goUp = (shift = '500', interval = 20): void => {
  const top = Math.max(document.body.scrollTop, document.documentElement.scrollTop)

  if (top > 0) {
    window.scrollBy(0, -shift)
    setTimeout(() => goUp(), interval)
  }
}
